import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import classNames from "classnames";
import { useAbility } from "@casl/react";
import { useTranslation } from "react-i18next";

import { Ripple } from "primereact/ripple";

import { AbilityContext } from "configs/CASLContext";
import { menu, menuPermissions } from "configs/menuConfig";

const AppSubmenu = (props) => {
    const ability = useAbility(AbilityContext);
    const { t } = useTranslation(["menu", "common"]);
    const [activeIndex, setActiveIndex] = useState(null);

    const onMenuItemClick = (event, item, index) => {
        //avoid processing disabled items
        if (item.disabled) {
            event.preventDefault();
            return true;
        }

        //execute command
        if (item.command) {
            item.command({ originalEvent: event, item: item });
        }

        if (index === activeIndex) setActiveIndex(null);
        else setActiveIndex(index);

        if (props.onMenuItemClick) {
            props.onMenuItemClick({
                originalEvent: event,
                item: item,
            });
        }
    };

    const renderLinkContent = (item) => {
        let submenuIcon = item.items && <i className="pi pi-fw pi-angle-down menuitem-toggle-icon"></i>;
        let badge = item.badge && <span className="menuitem-badge">{item.badge}</span>;

        return (
            <React.Fragment>
                <i className={item.icon}></i>
                <span>{t(item.id) || item.label}</span>
                {submenuIcon}
                {badge}
                <Ripple />
            </React.Fragment>
        );
    };

    const renderLink = (item, i) => {
        let content = renderLinkContent(item);
        if (item.to) {
            const permissions = menuPermissions[item.id];
            if (permissions?.length === 0 || (permissions?.length > 0 && permissions.some((permission) => ability.rules.some((rule) => rule.subject === permission.subject)))) {
                return (
                    <NavLink className="p-ripple" activeClassName="router-link-active router-link-exact-active" to={item.to} onClick={(e) => onMenuItemClick(e, item, i)} exact target={item.target}>
                        {content}
                    </NavLink>
                );
            }
        } else {
            return (
                <a href={item.url} className="p-ripple" onClick={(e) => onMenuItemClick(e, item, i)} target={item.target}>
                    {content}
                </a>
            );
        }
    };

    let items =
        props.items &&
        props.items.map((item, i) => {
            let active = activeIndex === i;
            let styleClass = classNames(item.badgeStyleClass, { "layout-menuitem-category": props.root, "active-menuitem": active && !item.to });
            if (props.root) {
                const permissions = menuPermissions[item.id];
                if (permissions?.length === 0 || (permissions?.length > 0 && permissions.some((permission) => ability.rules.some((rule) => rule.subject === permission.subject)))) {
                    return (
                        <li className={styleClass} key={i}>
                            {props.root === true && (
                                <React.Fragment>
                                    <div className="layout-menuitem-root-text">{t(item.id) || item.label}</div>
                                    <AppSubmenu items={item.items} onMenuItemClick={props.onMenuItemClick} />
                                </React.Fragment>
                            )}
                        </li>
                    );
                }
                return <></>;
            } else {
                return (
                    <li className={styleClass} key={i}>
                        {renderLink(item, i)}
                        <CSSTransition classNames="layout-submenu-wrapper" timeout={{ enter: 1000, exit: 450 }} in={active} unmountOnExit>
                            <AppSubmenu items={item.items} onMenuItemClick={props.onMenuItemClick} />
                        </CSSTransition>
                    </li>
                );
            }
        });

    return items ? <ul className={props.className}>{items}</ul> : null;
};

export const AppMenu = (props) => {
    return (
        <div className="layout-menu-container">
            <AppSubmenu items={menu} className="layout-menu" onMenuItemClick={props.onMenuItemClick} root={true} />
        </div>
    );
};
